import React from "react";
import { Field, reduxForm } from "redux-form";
import { Redirect } from "react-router-dom";
import FormElement from "../../forms/form_element";
import Spinner from "../../lib/spinner";

let ForgotPasswordForm = props => {
  if (typeof props.user !== "undefined" && props.user !== null) {
    return <Redirect to="/" />;
  }

  return (
    <form onSubmit={props.handleSubmit}>
      <Spinner isLoading={props.isLoading} />
      <div>
        <Field name="email" component={FormElement} type="email" label="Email" />
      </div>
      <hr className="redcircle-divider" />
      <button disabled={!props.submitEnabled} type="submit" className="btn btn-primary btn-block">
        Send Password Reset Link
      </button>
      <div className="user-form__fine-print">
        Need more help? <a href="mailto:support@getredcircle.com">Contact Support</a>
      </div>
    </form>
  );
};

ForgotPasswordForm = reduxForm({
  form: "forgot-password",
})(ForgotPasswordForm);

export default ForgotPasswordForm;
